const verifications = document.querySelectorAll('.js-verification-code');

const setVerification = (wrapper) => {
  const inputsWrapper = wrapper.querySelector('.js-inputs-wrapper');
  if (!inputsWrapper) {
    return;
  }

  const inputs = [...inputsWrapper.querySelectorAll('input')];

  inputs.forEach((elInput, index) => {
    elInput.addEventListener('keydown', (evt) => {
      if ((evt.code === 'Backspace' || evt.which === 8) && evt.target.value === '') {
        inputs[Math.max(0, index - 1)].focus();
      }
    });

    elInput.addEventListener('input', (evt) => {
      const [first, ...rest] = evt.target.value;
      evt.target.value = (first !== null && typeof first !== 'undefined') ? first : '';
      const lastInputBox = index === inputs.length - 1;
      const insertedContent = typeof first !== 'undefined';
      if (insertedContent && !lastInputBox) {
        inputs[index + 1].focus();
        inputs[index + 1].value = rest.join('');
        inputs[index + 1].dispatchEvent(new Event('input'));
      }
    });
  });
};

const checkLogPass = () => {
  if (verifications.length <= 0) {
    return;
  }

  verifications.forEach((wrapper) => {
    setVerification(wrapper);
  });
};

export {checkLogPass};
